<template>
  <!-- :class="{ collapsed: isCollapsed }" -->
  <div class="sidebar">
    <div class="logo_sidebar">
         <img src="../../assets/logo/logo.png">
         <p>建工检测客户服务平台</p>
    </div>
    <!-- <div class="sidebar-header">
      <span v-if="!isCollapsed" class="sidebar-title">主导航</span>
      <div class="collapse-toggle" @click="$emit('toggle-sidebar')">
        <i class="fa-solid" :class="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
      </div>
    </div> -->
    <!-- :title="isCollapsed ? item.name : ''" -->
    <ul class="sidebar-menu">
      <li 
        v-for="item in sideMenus" 
        :key="item.id"
        class="sidebar-item"
        :class="{ active: currentSideMenu === item.id }"
        @click="switchMenu(item)"
        :title="item.name"
      >
        <img :src="item.icon" alt="">
        <span>{{ item.name }}</span>
        <!-- <span v-if="!isCollapsed">{{ item.name }}</span> -->
        <!-- <div v-if="isCollapsed" class="sidebar-tooltip">
          {{ item.name }}
        </div> -->
      </li>
    </ul>
    

  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, defineProps, defineEmits,onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { MenuItem } from '@/types';
import newTw from '@/assets/image/new_wt.png'
import process from '@/assets/image/process.png'

// const props = defineProps<{
//   isCollapsed: boolean;
// }>();

const emit = defineEmits(['toggle-sidebar']);
const previousRoute = ref(null);
const route = useRoute();
const router = useRouter();

const currentSideMenu = ref('home');
// const isCollapsed = ref(false);

const sideMenus = computed(() => {
  const menuMap: Record<string, MenuItem[]> = {
    dashboard: [
      { id: 'home', name: '新建委托', icon: newTw, path: '/home' },
      { id: 'createEntrust', name: '进度查询', icon: process, path: '/createEntrust' },
      { id: 'notConditionProcess', name: '不符合试验条件样品', icon: process, path: '/notConditionProcess' },
      { id: 'myProject', name: '我的工程', icon: process, path: '/myProject' },
      { id: 'mySignatureComponent', name: '我的签名', icon: process, path: '/mySignature' },
    ],
 
  };
  
  const currentTopMenu = route.path.split('/')[1] || 'dashboard';
  return menuMap[currentTopMenu] || menuMap.dashboard;
});

// watch(route, (newRoute) => {
//   const pathParts = newRoute.path.split('/');
//   if (pathParts.length > 2) {
//     currentSideMenu.value = pathParts[2];
//   } else {
//     currentSideMenu.value = sideMenus.value[0]?.id || '';
//   }
// }, { immediate: true });
// 在路由守卫中记录上一个路由
router.beforeEach((to, from) => {
  previousRoute.value = from;
  return true;
});
// 根据当前路由设置活动菜单项
const setActiveMenuFromRoute = () => {
  const currentPath = route.path;
  const menu = sideMenus.value.find(item => item.path === currentPath);
  if (menu) {
    currentSideMenu.value = menu.id;
  }else{
     if (previousRoute.value) {
      // 可以根据上一个路由做不同的处理
      if (previousRoute.value.path === '/notConditionProcess') {
        currentSideMenu.value = 'notConditionProcess';
      }else{
        currentSideMenu.value = 'createEntrust';
      }
    }
    
  }
};

// 初始化时设置活动菜单
onMounted(() => {
  setActiveMenuFromRoute();
});
// 监听路由变化
watch(() => route.path, () => {
  setActiveMenuFromRoute();
});
const switchMenu = (menu: MenuItem) => {
  currentSideMenu.value = menu.id;
  if (menu.path) {
    router.push(menu.path);
  }
};
// setActiveMenuFromRoute()
</script>

<style lang="less" scoped>
@import '@/styles/variables.less';

.sidebar {
  width: 220px;
  height: 100vh;
  background-color: var(--dark-color);
  color: var(--text-light);
  transition: all 0.3s ease;
  box-shadow: var(--shadow);
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  position: sticky;
  // top: 60px;
  z-index: 99;
  
  &.collapsed {
    width: 70px;
    
    .sidebar-title, .sidebar-item span {
      display: none;
    }
    
    .sidebar-header {
      justify-content: center;
      padding: 15px 0;
    }
    
    .sidebar-item {
      justify-content: center;
      padding: 15px;
    }
    
    .sidebar-footer {
      display: none;
    }
  }
}
.logo_sidebar{
    text-align: center;
    margin-top: 20px;
    img{
      width: 50px;
      height: 58px;
      margin-bottom: 10px;
    }
    p{
      font-size: 15px;
      font-weight: bold;
    }
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.collapse-toggle {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.sidebar-menu {
  flex: 1;
  list-style: none;
  padding: 20px 0;
  margin-top: 50px;
}

.sidebar-item {
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: @transition;
  position: relative;
  margin-bottom: 15px;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    
    .sidebar-tooltip {
      display: block;
    }
  }
  
  &.active {
    background-color: var(--primary-color);
    // border-left: 4px solid var(--accent-color);
  }
}

.sidebar-tooltip {
  display: none;
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--dark-color);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  
  &::before {
    content: '';
    position: absolute;
    left: -4px;
    top: 50%;
    transform: translateY(-50%);
    border-width: 4px 4px 4px 0;
    border-style: solid;
    border-color: transparent var(--dark-color) transparent transparent;
  }
}

.sidebar-footer {
  padding: 15px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.system-info {
  text-align: center;
}

.system-status {
  font-size: 0.9rem;
  margin-bottom: 5px;
  color: var(--success-color);
}

.system-version {
  font-size: 0.8rem;
  opacity: 0.7;
}

// @media (max-width: 768px) {
//   .sidebar {
//     position: fixed;
//     left: 0;
//     z-index: 1000;
//     transform: translateX(0);
//     transition: transform 0.3s ease;
    
//     &.collapsed {
//       transform: translateX(-100%);
//       width: 250px;
      
//       .sidebar-title, .sidebar-item span {
//         display: block;
//       }
      
//       .sidebar-item {
//         justify-content: flex-start;
//         padding: 12px 20px;
//       }
//     }
//   }
  
//   .content.sidebar-collapsed {
//     margin-left: 0;
//   }
// }
</style>